/* eslint-disable */
export default [
  {
    path: '/online-service/:folder',
    name: 'online-service-folder',
    component: () => import('@/views/cont-user/online-service'),
    meta: {
      layout: 'wr',
      resource: 'Auth',
      action: 'read',
      contentRenderer: 'sidebar',
      contentClass: 'online-application',
      navActiveLink: 'online-service',
    },
    beforeEnter(to, _, next) {
      if (
        ['booking-online', 'schedule', 'track-trace', 'cfs-finder'].includes(
          to.params.folder
        )
      ) {
        next();
      } else {
        next({ name: 'error-404' });
      }
    },
  },
  {
    path: '/admin/master-data',
    name: 'master-data',
    component: () => import('@/views/admin/MasterData.vue'),
    meta: {
      pageTitle: 'Master Data',
      breadcrumb: [
        {
          text: 'WR1 ADMIN',
        },
        {
          text: 'Master Data',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/customer-dashboard',
    name: 'customer-dashboard',
    component: () => import('@/views/dashboard/Customer.vue'),
    meta: {
      pageTitle: 'Customer Dashboard',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },
  // *================My WR1===============================---*
  {
    path: '/admin/my-quotation',
    name: 'my-wr1-quotation',
    props: true,
    component: () => import('@/views/wr1/MyWr1Quotation.vue'),
    meta: {
      pageTitle: 'My Quotation',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'My Quotation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/my-booking',
    name: 'my-wr1-booking',
    props: true,

    component: () => import('@/views/wr1/MyWr1Booking.vue'),
    meta: {
      pageTitle: 'My Booking',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'My Booking',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user/my-booking',
    name: 'user-my-booking',
    props: true,

    component: () => import('@/views/cont-user/MyUserBooking.vue'),
    meta: {
      pageTitle: 'My Booking',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'My Booking',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user/my-quotation',
    name: 'user-my-quotation',
    props: true,

    component: () => import('@/views/cont-user/MyUserQuotation.vue'),
    meta: {
      pageTitle: 'My Quotation',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'My Quotation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user/estimate-price',
    name: 'user-estimate-price',
    props: true,

    component: () => import('@/views/cont-user/EstimatePrice.vue'),
    meta: {
      pageTitle: 'Estimate Price',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'Estimate Price',
          active: true,
        },
      ],
    },
  },

  {
    path: '/admin/my-booking-note',
    name: 'admin-my-booking-note',
    props: true,

    component: () => import('@/views/wr1/booking-note/MyWr1BookingNote.vue'),
    meta: {
     
      pageTitle: 'My Booking Note',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'My Booking Note',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user/find-a-quotation',
    name: 'find-a-quotation',
    component: () => import('@/views/cont-user/FindQuotation.vue'),
    meta: {
      pageTitle: 'My Quotation',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'Find a Quotation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/user-list',
    name: 'user-list',
    component: () => import('@/views/wr1/UserMgmtForCustomer.vue'),
    props: true,

    meta: {
      pageTitle: 'User List',
      breadcrumb: [
        {
          text: 'My Profile',
        },
        {
          text: 'User List',
          active: true,
        },
      ],
    },
  },
  // {
  //     path: '/admin/user-list/:idUser',
  //     name: 'user-list-props',
  //     component: () =>
  //         import ('@/views/wr1/UserMgmtForCustomer.vue'),
  //     props: true,

  //     meta: {
  //         navActiveLink: 'user-list',

  //         pageTitle: 'User List',
  //         breadcrumb: [{
  //                 text: 'My Profile',
  //             },
  //             {
  //                 text: 'User List',
  //                 active: true,
  //             },
  //         ],
  //     },
  // },

  {
    path: '/admin/location',
    name: 'location',
    component: () => import('@/views/wr1/Location/Location.vue'),
    props: true,
    meta: {
      pageTitle: 'Location',
      breadcrumb: [
        {
          text: 'My Profile',
        },
        {
          text: 'Location',
          active: true,
        },
      ],
    },
  },
  // {
  //     path: '/admin/location/:idUser',
  //     name: 'location-props',
  //     component: () =>
  //         import ('@/views/wr1/Location/Location.vue'),
  //     props: true,
  //     meta: {
  //         navActiveLink: 'location',

  //         pageTitle: 'Location',
  //         breadcrumb: [{
  //                 text: 'My Profile',
  //             },
  //             {
  //                 text: 'Location',
  //                 active: true,
  //             },
  //         ],
  //     },
  // },
  {
    path: '/user/schedule',
    name: 'schedule',
    component: () => import('@/views/wr1/Schedule.vue'),
    meta: {
      pageTitle: 'Schedule',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'Schedule',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/schedule-list',
    // name: 'schedule',
    name: 'schedule-list',

    component: () => import('@/views/wr1/schedule-list/ScheduleList.vue'),
    meta: {
      pageTitle: 'Schedule List',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'Schedule List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/track-trace',
    name: 'track-trace',
    component: () => import('@/views/wr1/TrackTrace.vue'),
    meta: {
      pageTitle: 'Track & Traces',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'Track & Trace',
          active: true,
        },
      ],
    },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () =>
      import('@/views/wr1/notifications/AccountSettingNotification.vue'),
    meta: {
      pageTitle: 'Notifications',
      breadcrumb: [
        {
          text: 'My Profile',
        },
        {
          text: 'Notifications',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/notifications-settings',
    name: 'admin-notification',
    component: () => import('@/views/admin/AccountSettingNotification.vue'),
    meta: {
      pageTitle: 'Notifications Settings',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'Notifications Settings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/company-manager',
    name: 'company-manager',
    component: () => import('@/views/admin/company-manager/CompanyManager.vue'),
    meta: {
      pageTitle: 'Company Manager',
      breadcrumb: [
        {
          text: 'Admin',
        },
        {
          text: 'Company Manager',
          active: true,
        },
      ],
    },
  },

  // customs-sub-dept
  {
    path: '/customs-sub-dept',
    name: 'customs-sub-dept',
    component: () => import('@/views/wr1/customs-sub-dept/index.vue'),
    meta: {
      pageTitle: 'Customs Sub-department',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'Customs Sub-department',
          active: true,
        },
      ],
    },
  },
];
